export default "__VITE_ASSET__BMgSvg$$__"